export const findIndex = (element, args) => {
	let index
	args.forEach(arg => {
		index = args.findIndex(arg => arg === element)
	})
	return index
}

export const findItem = (key, args, field = 'id') => {
	const item = args.filter(i => `${i[field]}`===key)[0]
	return item
}

export const getAttributes = node => {
	let attr = {}
	Object.keys(node).forEach(key => {
		const match = node[key].name.match(/^data\-(\S+)/)
		if (match) {
			let keyname = snakeToCamel(match[1])
			let value = node[key].value
			if (value == 'true') {
				value = true
			} else if (value == 'false') {
				value = false
			}
			attr[keyname] = value
		}
	})
	return attr
}

export const snakeToCamel = str => {
	return str.replace(/-./g, s => {
		return s.charAt(1).toUpperCase()
	})
}

export const camelToSnake = str => {
	return str.replace(/([A-Z])/g, s => {
		return '_' + s.charAt(0).toLowerCase()
	})
}